module.exports = __webpack_public_path__ + "img/MenuButton_ACT.7e4e1f2a.jpeg";